
export { createSenmonkaQuestionBlock };
import { formatDate } from '../formatDate';
import { imp } from '../../helpers/gtm';

function createSenmonkaQuestionBlock(question, options) {
  const $row = document.createElement('div');
  $row.id = 'question-' + question.id;
  $row.classList.add('col-xs-12', 'col-md-6');
  {
    const $a = document.createElement('a');
    $a.href = options.senmonka_url + 'questions/view/' + question.id;
    {
      const $topBox = document.createElement('div');
      $topBox.classList.add('box-top', 'row');
      {
        const $col = document.createElement('div');
        $col.classList.add('col-xs-2');
        {
          const $img = document.createElement('img');
          $img.classList.add('is-rounded', 'mb5', 'is-w100');
          $img.src = question.member_profile.portrait_path_full;
          $img.alt = question.member_profile.nickname;
          $col.appendChild($img);
        }
        $topBox.appendChild($col);
      }
      {
        const $col = document.createElement('div');
        $col.classList.add('col-xs-5', 'text-elps');
        {
          const $span = document.createElement('span');
          $span.textContent = question.member_profile.nickname;
          $col.appendChild($span);
          const $br = document.createElement('br');
          $col.appendChild($br);
          {
            // シンボル
            for (let i = 0; i < question.state_at_posted.length; i++) {
              const $symbol = document.createElement('span');
              $symbol.classList.add('babysymbol', 'fz-i', 'c-pink', 'mr5');
              if (
                question.state_at_posted[i].key === 'child_na_birthday' ||
                question.state_at_posted[i].key === 'child_boy_birthday' ||
                question.state_at_posted[i].key === 'child_girl_birthday'
              ) {
                $symbol.classList.add('babysymbol-baby');
              } else if (question.state_at_posted[i].key === 'estimated_date_of_delivery') {
                $symbol.classList.add('babysymbol-maternity');
              }
              $col.appendChild($symbol);
              // 月齢または妊娠週数
              const $meta = document.createElement('span');
              $meta.textContent = question.state_at_posted[i].state;
              $col.appendChild($meta);
            }
          }
        }
        $topBox.appendChild($col);
      }
      {
        const $col = document.createElement('div');
        $col.classList.add('col-xs-5', 'text-right');
        {
          const $date = document.createElement('span');
          $date.classList.add('c-pink');
          $date.textContent = formatDate(new Date(question.posted));
          $col.appendChild($date);
          const $br = document.createElement('br');
          $col.appendChild($br);
          const $icon = document.createElement('span');
          $icon.classList.add('babysymbol', 'babysymbol-view', 'fz-i', 'mr5');
          $col.appendChild($icon);
          const $view = document.createElement('span');
          $view.textContent = question.page_views_count;
          $col.appendChild($view);
        }
        $topBox.appendChild($col);
      }
      $a.appendChild($topBox);
    }
    {
      const $middleBox = document.createElement('div');
      $middleBox.classList.add('box-middle');
      {
        const $p = document.createElement('p');
        $p.classList.add('fw-bold');
        $p.textContent = question.title;
        $middleBox.appendChild($p);
      }
      {
        const $p = document.createElement('p');
        $p.classList.add('mb10', 'line-clamp', 'is-2');
        $p.textContent = question.body;
        $middleBox.appendChild($p);
      }
      $a.appendChild($middleBox);
    }
    {
      const $bottomBox = document.createElement('div');
      $bottomBox.classList.add('box-bottom', 'row', 'between-xs');
      {
        const $col = document.createElement('div');
        $col.classList.add('col-xs-6');
        // 相談ステータスラベル
        if (question.status === 0) {
          const $label = document.createElement('div');
          $label.classList.add('label-answer');
          $label.textContent = '専門家回答待ち';
          $col.appendChild($label);
        } else if (question.status === 4) {
          const $label = document.createElement('div');
          $label.classList.add('label-answer');
          $label.textContent = '非表示';
          $col.appendChild($label);
        } else {
          const $label = document.createElement('div');
          $label.classList.add('label-answer', 'label-answer-hasa');
          $label.textContent = '専門家回答あり';
          const $heart = document.createElement('span');
          $heart.classList.add('babysymbol', 'babysymbol-heart');
          $heart.textContent = question.comments_likes_count + '';
          $label.appendChild($heart);
          $col.appendChild($label);
        }
        $bottomBox.appendChild($col);
      }
      {
        const $col = document.createElement('div');
        $col.classList.add('col-xs-6', 'text-right');
        {
          const $span = document.createElement('span');
          $span.classList.add('label-round', 'is-palepink');
          $span.textContent = question.topic_name;
          $col.appendChild($span);
        }
        $bottomBox.appendChild($col);
      }
      $a.appendChild($bottomBox);
    }
    $row.appendChild(imp($a, question.title));
  }
  return $row;
}
